import { useCallback, useEffect, useRef, useState, type AnimationEvent } from 'react';

export const PRODUCT_STAGED_FLASH_ANIMATION = 'product-staged-flash';

export function useFlashFeedback(
  animationName: string = PRODUCT_STAGED_FLASH_ANIMATION,
) {
  const [flashingId, setFlashingId] = useState<string | null>(null);
  const flashFrameRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (flashFrameRef.current !== null) {
        cancelAnimationFrame(flashFrameRef.current);
      }
    };
  }, []);

  const flash = useCallback((id: string) => {
    if (flashFrameRef.current !== null) {
      cancelAnimationFrame(flashFrameRef.current);
    }

    setFlashingId(null);
    flashFrameRef.current = requestAnimationFrame(() => {
      setFlashingId(id);
      flashFrameRef.current = null;
    });
  }, []);

  const isFlashing = useCallback(
    (id: string) => flashingId === id,
    [flashingId],
  );

  const handleAnimationEnd = useCallback(
    (id: string, event: AnimationEvent) => {
      if (event.animationName === animationName && flashingId === id) {
        setFlashingId(null);
      }
    },
    [animationName, flashingId],
  );

  return { flash, isFlashing, handleAnimationEnd };
}
